import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Typography,
  CircularProgress,
  makeStyles,
  IconButton,
  InputBase,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import AssignmentIcon from "@material-ui/icons/Assignment";
import SearchIcon from "@material-ui/icons/Search";
import api from "../../services/api";

const useStyles = makeStyles((theme) => ({
  dialog: {
    "& .MuiDialog-paper": {
      borderRadius: 12,
      maxWidth: 420,
      width: "100%",
    },
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "12px 16px 8px",
  },
  title: {
    fontWeight: 600,
    fontSize: 16,
  },
  searchBox: {
    display: "flex",
    alignItems: "center",
    background: theme.palette.type === "dark" ? "#2a3942" : "#f0f2f5",
    borderRadius: 8,
    padding: "4px 10px",
    margin: "0 16px 8px",
  },
  searchInput: {
    flex: 1,
    fontSize: 14,
  },
  list: {
    padding: 0,
    maxHeight: 360,
    overflowY: "auto",
  },
  listItem: {
    cursor: "pointer",
    "&:hover": {
      background: theme.palette.type === "dark" ? "#2a3942" : "#f5f5f5",
    },
  },
  icon: {
    color: "#7c3aed",
    minWidth: 40,
  },
  emptyText: {
    textAlign: "center",
    color: theme.palette.text.secondary,
    padding: "24px 16px",
    fontSize: 14,
  },
  statusChip: {
    fontSize: 10,
    fontWeight: 600,
    padding: "1px 6px",
    borderRadius: 4,
    background: "#dcfce7",
    color: "#15803d",
    marginLeft: 6,
  },
}));

const FormSelectModal = ({ open, onClose, onSelect }) => {
  const classes = useStyles();
  const [quizzes, setQuizzes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");

  useEffect(() => {
    if (!open) return;
    setLoading(true);
    api.get("/quizzes")
      .then((res) => {
        const data = Array.isArray(res.data) ? res.data : (res.data?.quizzes || []);
        setQuizzes(data.filter((q) => q.status === "published"));
      })
      .catch(() => setQuizzes([]))
      .finally(() => setLoading(false));
  }, [open]);

  const filtered = quizzes.filter((q) =>
    q.name?.toLowerCase().includes(search.toLowerCase())
  );

  const handleSelect = (quiz) => {
    if (onSelect) onSelect(quiz);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} className={classes.dialog}>
      <div className={classes.header}>
        <Typography className={classes.title}>Selecionar Formulário</Typography>
        <IconButton size="small" onClick={onClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </div>

      <div className={classes.searchBox}>
        <SearchIcon style={{ fontSize: 18, marginRight: 6, opacity: 0.5 }} />
        <InputBase
          className={classes.searchInput}
          placeholder="Buscar formulário..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <DialogContent style={{ padding: 0 }}>
        {loading ? (
          <div style={{ textAlign: "center", padding: 24 }}>
            <CircularProgress size={28} />
          </div>
        ) : filtered.length === 0 ? (
          <Typography className={classes.emptyText}>
            {search ? "Nenhum formulário encontrado." : "Nenhum formulário publicado disponível."}
          </Typography>
        ) : (
          <List className={classes.list}>
            {filtered.map((quiz) => (
              <ListItem
                key={quiz.id}
                className={classes.listItem}
                onClick={() => handleSelect(quiz)}
              >
                <ListItemIcon className={classes.icon}>
                  <AssignmentIcon />
                </ListItemIcon>
                <ListItemText
                  primary={
                    <span>
                      {quiz.name}
                      <span className={classes.statusChip}>publicado</span>
                    </span>
                  }
                  secondary={quiz.description || null}
                />
              </ListItem>
            ))}
          </List>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default FormSelectModal;
